import { render, staticRenderFns } from "./train-verification.vue?vue&type=template&id=68e8bed8"
import script from "./train-verification.vue?vue&type=script&lang=js"
export * from "./train-verification.vue?vue&type=script&lang=js"
import style0 from "./train-verification.vue?vue&type=style&index=0&id=68e8bed8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports